
jQuery(document).ready(function () {
    jQuery('.wp-google-stars').click(function (e) { 
        e.preventDefault();
        jQuery('.wp-google-wr a').click();
    });
});